import {
  ORDER_ADMIN_LIST_FAIL,
  ORDER_ADMIN_LIST_REQUEST,
  ORDER_ADMIN_LIST_SUCCESS,
  ORDER_CANCEL_FAIL,
  ORDER_CANCEL_REQUEST,
  ORDER_CANCEL_RESET,
  ORDER_CANCEL_SUCCESS,
  ORDER_CREATE_FAIL,
  ORDER_CREATE_REQUEST,
  ORDER_CREATE_RESET,
  ORDER_CREATE_SUCCESS,
  ORDER_DELETE_FAIL,
  ORDER_DELETE_REQUEST,
  ORDER_DELETE_RESET,
  ORDER_DELETE_SUCCESS,
  ORDER_DELIVER_FAIL,
  ORDER_DELIVER_REQUEST,
  ORDER_DELIVER_RESET,
  ORDER_DELIVER_SUCCESS,
  ORDER_DETAILS_FAIL,
  ORDER_DETAILS_REQUEST,
  ORDER_DETAILS_RESET,
  ORDER_DETAILS_SUCCESS,
  ORDER_DISMISS_REFUND_FAIL,
  ORDER_DISMISS_REFUND_REQUEST,
  ORDER_DISMISS_REFUND_RESET,
  ORDER_DISMISS_REFUND_SUCCESS,
  ORDER_LIST_FAIL,
  ORDER_LIST_REQUEST,
  ORDER_LIST_SUCCESS,
  ORDER_PAY_FAIL,
  ORDER_PAY_REQUEST,
  ORDER_PAY_RESET,
  ORDER_PAY_SUCCESS,
  ORDER_REFUND_FAIL,
  ORDER_REFUND_REQUEST,
  ORDER_REFUND_RESET,
  ORDER_REFUND_SUCCESS,
  ORDER_SEND_FAIL,
  ORDER_SEND_REQUEST,
  ORDER_SEND_RESET,
  ORDER_SEND_SUCCESS,
} from '../constants/orderConstants';

export const orderCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case ORDER_CREATE_REQUEST:
      return { loading: true };
    case ORDER_CREATE_SUCCESS:
      return { loading: false, success: true, order: action.payload };
    case ORDER_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case ORDER_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

export const orderDetailsReducer = (state = { loading: true }, action) => {
  switch (action.type) {
    case ORDER_DETAILS_REQUEST:
      return { loading: true };
    case ORDER_DETAILS_SUCCESS:
      return { loading: false, order: action.payload };
    case ORDER_DETAILS_FAIL:
      return { loading: false, error: action.payload, errorStatus: action.statusCode };
    case ORDER_DETAILS_RESET:
      return { loading: true };
    default:
      return state;
  }
};

export const orderPayReducer = (state = {}, action) => {
  switch (action.type) {
    case ORDER_PAY_REQUEST:
      return { loading: true };
    case ORDER_PAY_SUCCESS:
      return { loading: false, success: true };
    case ORDER_PAY_FAIL:
      return { loading: false, error: action.payload };
    case ORDER_PAY_RESET:
      return {};
    default:
      return state;
  }
};

export const orderListReducer = (state = { orders: [] }, action) => {
  switch (action.type) {
    case ORDER_LIST_REQUEST:
      return { loading: true };
    case ORDER_LIST_SUCCESS:
      return { loading: false, orders: action.payload };
    case ORDER_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const orderAdminListReducer = (state = { orders: [], total: 0 }, action) => {
  switch (action.type) {
    case ORDER_ADMIN_LIST_REQUEST:
      return { ...state, loading: true };
    case ORDER_ADMIN_LIST_SUCCESS:
      return {
        loading: false,
        orders: action.payload.items,
        total: action.payload.total,
        page: action.payload.page,
        pages: action.payload.pages,
      };
    case ORDER_ADMIN_LIST_FAIL:
      return { loading: false, error: action.payload, orders: [], total: 0 };
    default:
      return state;
  }
};

export const orderDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case ORDER_DELETE_REQUEST:
      return { loading: true };
    case ORDER_DELETE_SUCCESS:
      return { loading: false, success: true };
    case ORDER_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case ORDER_DELETE_RESET:
      return {};
    default:
      return state;
  }
};

export const orderSendReducer = (state = {}, action) => {
  switch (action.type) {
    case ORDER_SEND_REQUEST:
      return { loading: true };
    case ORDER_SEND_SUCCESS:
      return { loading: false, success: true };
    case ORDER_SEND_FAIL:
      return { loading: false, error: action.payload };
    case ORDER_SEND_RESET:
      return {};
    default:
      return state;
  }
};

export const orderDeliverReducer = (state = {}, action) => {
  switch (action.type) {
    case ORDER_DELIVER_REQUEST:
      return { loading: true };
    case ORDER_DELIVER_SUCCESS:
      return { loading: false, success: true };
    case ORDER_DELIVER_FAIL:
      return { loading: false, error: action.payload };
    case ORDER_DELIVER_RESET:
      return {};
    default:
      return state;
  }
};

export const orderCancelReducer = (state = {}, action) => {
  switch (action.type) {
    case ORDER_CANCEL_REQUEST:
      return { loading: true };
    case ORDER_CANCEL_SUCCESS:
      return { loading: false, success: true };
    case ORDER_CANCEL_FAIL:
      return { loading: false, error: action.payload };
    case ORDER_CANCEL_RESET:
      return {};
    default:
      return state;
  }
};

export const orderRefundReducer = (state = {}, action) => {
  switch (action.type) {
    case ORDER_REFUND_REQUEST:
      return { loading: true };
    case ORDER_REFUND_SUCCESS:
      return { loading: false, success: true };
    case ORDER_REFUND_FAIL:
      return { loading: false, error: action.payload };
    case ORDER_REFUND_RESET:
      return {};
    default:
      return state;
  }
};

export const orderDismissRefundReducer = (state = {}, action) => {
  switch (action.type) {
    case ORDER_DISMISS_REFUND_REQUEST:
      return { loading: true };
    case ORDER_DISMISS_REFUND_SUCCESS:
      return { loading: false, success: true };
    case ORDER_DISMISS_REFUND_FAIL:
      return { loading: false, error: action.payload };
    case ORDER_DISMISS_REFUND_RESET:
      return {};
    default:
      return state;
  }
};
